import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import Store from '../../store';
import ProductStore from '../../store/productStore';
import { JoinableProduct } from '../Products/JoinableProductCard';

import InterimJoinCard from './InterimJoinCard';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

interface InjectedProps {
  productStore: ProductStore;
}

const compareSiteSize = (a: JoinableProduct, b: JoinableProduct): number => {
  if (a.siteSize === undefined || b.siteSize === undefined) {
    return 0;
  }
  return b.siteSize - a.siteSize;
};
@observer
class InterimJoinCards extends React.Component<InjectedProps> {
  render() {
    const { joinableProducts } = this.props.productStore;
    return (
      <Container>
        {joinableProducts
          .slice()
          .sort(compareSiteSize)
          .map(({ cloudId, productName, url, siteName, siteSize }) => (
            <InterimJoinCard
              cloudId={cloudId}
              key={`${siteName}${productName}`}
              productName={productName}
              siteName={siteName}
              usersCount={siteSize}
              url={url}
            />
          ))}
      </Container>
    );
  }
}

export default inject(({ productStore }: Store) => ({
  productStore,
}))(InterimJoinCards);
